import * as React from 'react';
import { Modal } from 'reactstrap';
import { connect } from 'react-redux';
import get from 'lodash.get';
import NoodleButton from 'components/uielements/Button';
import type { PromptModalOption } from 'commons/types';
import PromptModalWrapper from './PromptModal.style';
import type { PromptModalProps } from './PromptModal.types';

const renderOptions = (options: PromptModalOption[]): React.ReactElement<any>[] =>
  options.map(({ label, value, color, onClick }) => (
    <NoodleButton
      className='button-options__item'
      color={color}
      key={value}
      onClick={onClick}
      size='medium'
      value={value}
    >
      {label}
    </NoodleButton>
  ));

const PromptModal = ({ isOpen, title, subtitle, options }: PromptModalProps) => {
  const modalConfig = {
    contentClassName: 'prompt-modal',
    centered: true,
    fade: false,
    isOpen,
  };
  return (
    <Modal {...modalConfig}>
      <PromptModalWrapper>
        <span className='text-headline-card prompt-modal__title'>{title}</span>
        <span className='text-content-subhead prompt-modal__subtitle'>{subtitle}</span>
        <div className='prompt-modal__buttons-container'>{renderOptions(options)}</div>
      </PromptModalWrapper>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  isOpen: get(state, 'modal.isOpen', false),
  title: get(state, 'modal.title', ''),
  subtitle: get(state, 'modal.subtitle', ''),
  options: get(state, 'modal.options', []),
});

export default connect(mapStateToProps)(PromptModal);
